import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[dlinputvalidation]'
})
export class InputValidationDirective {
  public regexStr = '^[a-zA-Z ]*$';

  public constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event'])
  public onKeyPress(event) {
    return new RegExp(this.regexStr).test(event.key);
  }
  @HostListener('paste', ['$event'])
  public blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }

  public validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').replace(/[^a-zA-Z ]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
